import React, { Component } from "react";
import {
   LOCALE_STORAGE_KEY,
   SUPPORTED_LOCALES,
   applyLocale,
   getLocale,
   setLocale,
   subscribe,
   t
} from "./index";

export const I18nContext = React.createContext({ locale: getLocale(), t, setLocale });

// Re-renders the whole tree whenever the language changes, and keeps other browser tabs in sync.
export default class I18nProvider extends Component {
   state = { locale: getLocale() };

   componentDidMount() {
      this.unsubscribe = subscribe((locale) => this.setState({ locale }));
      window.addEventListener("storage", this.handleStorage);
   }

   componentWillUnmount() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener("storage", this.handleStorage);
   }

   // Cross-tab sync. Uses applyLocale (not setLocale) so this tab does not write the value back
   // and trigger an echo loop in the tab that originally changed it.
   handleStorage = (event) => {
      if (event.key !== LOCALE_STORAGE_KEY) return;
      if (SUPPORTED_LOCALES.indexOf(event.newValue) === -1) return;
      if (event.newValue === getLocale()) return;
      applyLocale(event.newValue);
   };

   render() {
      // A fresh value object per locale change is what propagates the update to consumers.
      const value = { locale: this.state.locale, t, setLocale };
      return <I18nContext.Provider value={value}>{this.props.children}</I18nContext.Provider>;
   }
}
